import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

export const selectManagerHeaderKey = createSelector(
  [selectPartner360Data],
  ({ managerHeaderKey }) => managerHeaderKey
)
